import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/transform.svg
 */
const IconTransform: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M4.794 5.403H.58A.58.58 0 010 4.819V.59A.587.587 0 01.58.003h4.214a.581.581 0 01.58.584V4.82a.583.583 0 01-.58.584zm10.894 5.716a.578.578 0 01-.581-.584.584.584 0 01.58-.583h1.08a.582.582 0 01.582.583v6.173a.585.585 0 01-.581.582h-6.209a.574.574 0 01-.536-.36.583.583 0 01-.045-.222v-1.647a.584.584 0 01.581-.583.579.579 0 01.58.583v1.064h5.048v-4.996l-.5-.01zm-1.586 2.748H7.82a.583.583 0 01-.581-.583V6.973a.583.583 0 01.58-.583h6.293a.58.58 0 01.579.583v6.31a.583.583 0 01-.58.584h-.009zM8.4 12.7h5.121V7.558h-5.12V12.7zm12.887-5.86a.583.583 0 01.58-.584.58.58 0 01.581.584v10.322a.584.584 0 01-.58.584.582.582 0 01-.581-.584V6.84zm-19.182.02a.578.578 0 01.992-.413c.11.11.17.258.17.413v10.323a.583.583 0 01-.58.583.58.58 0 01-.582-.583V6.86zM6.9 21.883a.58.58 0 01-.58-.583.584.584 0 01.58-.583h10.13a.58.58 0 01.58.583.584.584 0 01-.58.583H6.898zm0-18.595a.58.58 0 01-.58-.583.578.578 0 01.58-.583h10.13a.578.578 0 01.58.583.584.584 0 01-.58.583H6.898zm16.52 20.708h-4.213a.58.58 0 01-.58-.583V19.18a.578.578 0 01.58-.583h4.213a.58.58 0 01.581.584v4.23a.583.583 0 01-.57.588l-.01-.004zm-3.632-1.167h3.051v-3.064h-3.05v3.064zM23.42 5.4h-4.213a.58.58 0 01-.58-.584V.583a.584.584 0 01.58-.583h4.213A.582.582 0 0124 .583v4.232a.586.586 0 01-.57.588l-.01-.004zM19.787 4.23h3.051V1.168h-3.05V4.23zM4.794 23.996H.58A.58.58 0 010 23.413V19.18a.578.578 0 01.58-.583h4.214a.58.58 0 01.58.584v4.23a.586.586 0 01-.357.543.582.582 0 01-.223.045v-.004zM1.162 22.83h3.05v-3.064h-3.05v3.064zm0-18.598h3.05V1.168h-3.05V4.23z"
      fill="currentColor"
    />
  </svg>
);

export default IconTransform;
